import ActionIcon from './action-icon';
import { PanelLeft } from 'lucide-react';
import { useContext } from 'react';
import SideBarContext from '../../contexts/side-bar-context';
import { getCommandKey } from '../../lib/utils';
import IconHover from './icon-hover';

const SidebarToggle = ({ additionalclasses }) => {
  const { isSideBarOpen, toggleSideBar } = useContext(SideBarContext);


  return (
      
       <IconHover onClick={toggleSideBar} position='' additionalclasses={`${isSideBarOpen ? 'hover:custom-bg-white-50' : 'hover:custom-bg-white-200'} !py-[10px] lg:!px-[10px] rounded-[8px]`}>
        <ActionIcon  position='right' command={`${getCommandKey('⌘', 'Ctrl')} + \\ `} content={`${isSideBarOpen ? 'Close' : 'Open'} sidebar`}   color='custom-text-grey-800 ' >
          <PanelLeft size={20} color="currentColor" />
        </ActionIcon>
      </IconHover>
  );
};

export default SidebarToggle;